"use strict";

var _regeneratorRuntime = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keys = require("blockstack/lib/keys");

var _model = _interopRequireDefault(require("../model"));

var _groupMembership = _interopRequireDefault(require("./group-membership"));

var _groupInvitation = _interopRequireDefault(require("./group-invitation"));

var _signingKey = _interopRequireDefault(require("./signing-key"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultMembers = [];

var UserGroup =
/*#__PURE__*/
function (_Model) {
  _inherits(UserGroup, _Model);

  function UserGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UserGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UserGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "privateKey", void 0);

    return _this;
  }

  _createClass(UserGroup, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var signingKey, _ref, username, invitation;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _signingKey.default.create({
                  userGroupId: this._id
                });

              case 2:
                signingKey = _context.sent;
                this.attrs.signingKeyId = signingKey._id;
                this.privateKey = signingKey.attrs.privateKey;
                (0, _helpers.addUserGroupKey)(this); // await this.makeGaiaConfig();

                _ref = (0, _helpers.loadUserData)(), username = _ref.username;
                _context.next = 9;
                return this.makeGroupMembership(username);

              case 9:
                invitation = _context.sent;
                _context.next = 12;
                return invitation.activate();

              case 12:
                return _context.abrupt("return", this);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "makeGroupMembership",
    value: function () {
      var _makeGroupMembership = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(username) {
        var existingInviteId, _invitation, invitation;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                existingInviteId = null;
                this.attrs.members.forEach(function (member) {
                  if (member.username === username) {
                    existingInviteId = member.inviteId;
                  }
                });

                if (!existingInviteId) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return _groupInvitation.default.findById(existingInviteId, {
                  decrypt: false
                });

              case 5:
                _invitation = _context2.sent;
                return _context2.abrupt("return", _invitation);

              case 7:
                _context2.next = 9;
                return _groupInvitation.default.makeInvitation(username, this);

              case 9:
                invitation = _context2.sent;
                this.attrs.members.push({
                  username: username,
                  inviteId: invitation._id
                });
                _context2.next = 13;
                return this.save();

              case 13:
                return _context2.abrupt("return", invitation);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function makeGroupMembership(_x) {
        return _makeGroupMembership.apply(this, arguments);
      }

      return makeGroupMembership;
    }()
  }, {
    key: "publicKey",
    value: function publicKey() {
      return (0, _keys.getPublicKeyFromPrivate)(this.privateKey);
    }
  }, {
    key: "encryptionPublicKey",
    value: function () {
      var _encryptionPublicKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.publicKey());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function encryptionPublicKey() {
        return _encryptionPublicKey.apply(this, arguments);
      }

      return encryptionPublicKey;
    }()
  }, {
    key: "encryptionPrivateKey",
    value: function encryptionPrivateKey() {
      if (this.privateKey) {
        return this.privateKey;
      }

      var _ref2 = (0, _helpers.userGroupKeys)(),
          signingKeys = _ref2.signingKeys;

      return signingKeys[this.attrs.signingKeyId];
    }
  }, {
    key: "makeGaiaConfig",
    value: function () {
      var _makeGaiaConfig = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var userData, appPrivateKey, hubUrl, scopes, userSession, gaiaConfig;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                userData = (0, _helpers.loadUserData)();
                appPrivateKey = userData.appPrivateKey, hubUrl = userData.hubUrl;
                scopes = [{
                  scope: 'putFilePrefix',
                  domain: "UserGroups/".concat(this._id, "/")
                }];
                userSession = (0, _helpers.requireUserSession)();
                _context4.next = 6;
                return userSession.connectToGaiaHub(hubUrl, appPrivateKey, scopes);

              case 6:
                gaiaConfig = _context4.sent;
                this.attrs.gaiaConfig = gaiaConfig;
                return _context4.abrupt("return", gaiaConfig);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function makeGaiaConfig() {
        return _makeGaiaConfig.apply(this, arguments);
      }

      return makeGaiaConfig;
    }()
  }, {
    key: "getSigningKey",
    value: function getSigningKey() {
      var _ref3 = (0, _helpers.userGroupKeys)(),
          userGroups = _ref3.userGroups,
          signingKeys = _ref3.signingKeys;

      var id = userGroups[this._id];
      var privateKey = signingKeys[id];
      return {
        privateKey: privateKey,
        id: id
      };
    }
  }], [{
    key: "find",
    value: function () {
      var _find = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(id) {
        var _groupMembership$defa, userGroups, signingKeys, signingKey, privateKey, userGroup;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _groupMembership$defa = _groupMembership.default.userGroupKeys(), userGroups = _groupMembership$defa.userGroups, signingKeys = _groupMembership$defa.signingKeys;

                if (!(!userGroups || !userGroups[id])) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("UserGroup not found with id: '".concat(id, "'. Have you called `GroupMembership.cacheKeys()`?"));

              case 3:
                signingKey = userGroups[id];
                privateKey = signingKeys[signingKey];
                userGroup = new this({
                  _id: id
                });
                userGroup.privateKey = privateKey;
                _context5.next = 9;
                return userGroup.fetch();

              case 9:
                return _context5.abrupt("return", userGroup);

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function find(_x2) {
        return _find.apply(this, arguments);
      }

      return find;
    }()
  }, {
    key: "myGroups",
    value: function myGroups() {
      var _ref4 = (0, _helpers.userGroupKeys)(),
          userGroups = _ref4.userGroups;

      var keys = Object.keys(userGroups);
      return this.fetchList({
        _id: keys.join(',')
      });
    }
  }]);

  return UserGroup;
}(_model.default);

exports.default = UserGroup;

_defineProperty(UserGroup, "schema", {
  name: String,
  gaiaConfig: Object,
  members: {
    type: Array
  }
});

_defineProperty(UserGroup, "defaults", {
  members: defaultMembers
});

_defineProperty(UserGroup, "modelName", function () {
  return 'UserGroup';
});